import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const activityFeedUpdated = gql`
  subscription ActivityFeedSubscription {
    activityFeedUpdated {
      ...ActivityFeedItem
    }
  }

  ${Fragments.activity.activityFeedItem}
`;
